import React from 'react';
import { useTranslation } from 'react-i18next';

import { MenuItem, TextField } from '@material-ui/core';
import { OrganizationGroupCodesDto } from '.generated/api';

interface OrganizationGroupCodeSelectProps {
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  value?: string;
  required?: boolean;
  disabled?: boolean;
  helpText?: string;
}
const OrganizationGroupCodeSelect: React.FC<
  OrganizationGroupCodeSelectProps
> = ({ helpText, disabled, ...restProps }) => {
  const { t } = useTranslation(['translations']);
  return (
    <TextField
      variant="outlined"
      fullWidth
      select
      label={t(
        'organization_page.organization_information.labels.organization_group_code',
      )}
      name="groupCode"
      disabled={disabled}
      helperText={helpText}
      {...restProps}
    >
      <MenuItem>
        {t(
          'organization_page.organization_information.labels.select_group_code',
        )}
      </MenuItem>
      <MenuItem value={OrganizationGroupCodesDto.LASY}>
        {OrganizationGroupCodesDto.LASY}
      </MenuItem>
    </TextField>
  );
};

export default OrganizationGroupCodeSelect;
